import React, { useState, useEffect } from "react";
import * as Icon from "react-feather";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FiDownload } from "react-icons/fi";
import Avatar from "react-avatar-edit";
import { backendApi } from "../../api/apiService";
import html2pdf from 'html2pdf.js';
// import { MultiSelect } from 'primereact/multiselect';
import SendEmailComponent from "./sendEmailComponent";
// import 'primeicons/primeicons.css';
// import 'primereact/resources/themes/saga-blue/theme.css';
// import 'primereact/resources/primereact.css';
import {
    FaCamera,
} from "react-icons/fa";
function OfficeDetails({ candidate }) {
    const [todaysDate, settodaysDate] = useState(new Date());
    const [sendEmailPopupShow, setSendEmailPopupShow] = useState(false);
    const [flagReadactor, setflagReadactor] = useState(false);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
    const [expiryDate, setexpiryDate] = useState(currentDate);
    const [jobRole, setJobRole] = useState("");
    const [editedCandidate, setEditedCandidate] = useState({ ...candidate });
    const [officeName, setOfficeName] = useState();
    const [logoUrl, setLogoUrl] = useState();
    const [resumeDetails, setresumeDetails] = useState();
    const [attachmentDetails, setattachmentDetails] = useState([])
    const [SelectedAttachement, setSelectedAttachement] = useState([]);
    const [paymentDetails, setpaymentDetails] = useState({
        "Total Pay": ""
        // "CTC": "",
        // "Basic Pay": "",
        // "DA": "",
        // "HRA": "",
        // "Conveyance": "",
        // "Medical": "",
        // "LTA": "",
        // "SPL ALLW": "",
        // "Gross Pay": ""
    });
    const convertImageToBase64 = async (imgUrl) => {
        try {
          const response = await fetch(imgUrl);
          const blob = await response.blob();
    
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        } catch (error) {
          console.error('Error converting image to base64:', error);
          return null;
        }
      };
    
      useEffect(() => {
        const fetchData = async () => {
          try {
            let postData = {
              "functionName": "getSitedata",
              "site_id": localStorage.getItem("siteId"),
            };
            const result = await backendApi(postData);
            if (result.success === "1") {
              const base64Image = await convertImageToBase64(result.stage.logo_url);
              if (base64Image) {
                setLogoUrl(base64Image);
              }
              // Other logic you want to execute when the API call is successful
            }
          } catch (error) {
            console.error("Error fetching site data:", error);
          }
        };
        fetchData();
      }, []);
    useEffect(() => {
        const postData = {
            "functionName": "listSiteDoc",
            "site_id": localStorage.getItem("siteId"),
        }
        backendApi(postData).then((response) => {
            if (response.success === "1") {
                const attachmentOptions = response.dataSet
        .filter(attachment => attachment.is_active === 1)
        .map(attachment => ({
          label: attachment.doc_name,
          value: attachment.doc_url
        }));
                setattachmentDetails(attachmentOptions);

            } else {
                setattachmentDetails([]);
            }
        });
    }, []);



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditedCandidate({ ...editedCandidate, [name]: value });
    };
    const formatDate = (inputDate) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(inputDate).toLocaleDateString('en-IN', options);
        return formattedDate;
    }
    const handleFromDateChange = (date) => {
        settodaysDate(date);
        if (expiryDate < date)
            handleExpiryDateChange(date)
    };
    function closePopup() {
        setflagReadactor(false)
        setSendEmailPopupShow(false);
    };
    const handleExpiryDateChange = (date) => {
        setexpiryDate(date);
    };
    const toggleDropdown = () => {
        setIsDropdownVisible(!isDropdownVisible);
    };
    const generateEmail = (date) => {
        if (!editedCandidate.full_name) {
            toast.warn("Please Fill Name", {
                containerId: "P",
            });
            document.getElementById("full_name").focus()
            return
        }
        if (!editedCandidate.email_id) {
            toast.warn("Please Fill Email ID", {
                containerId: "P",
            });
            document.getElementById("email_id").focus()
            return
        }
        if (!jobRole) {
            toast.warn("Please Fill Job Role", {
                containerId: "P",
            });
            document.getElementById("JobRole").focus()
            return
        }
        if (!officeName) {
            toast.warn("Please Fill Office Name", {
                containerId: "P",
            });
            document.getElementById("companyName").focus()
            return
        }
        if (!todaysDate) {
            toast.warn("Please Fill Today's Date", {
                containerId: "P",
            });
            document.getElementById("totalPay").focus()
            return
        }
        if (!expiryDate) {
            toast.warn("Please Fill Expiry Date", {
                containerId: "P",
            });
document.getElementById("ExpiryDate").focus()
            return
        }
        if (!officeName) {
            toast.warn("Please Fill Office Name", {
                containerId: "P",
            });
            return;
        }
        if (paymentDetails["Total Pay"] === undefined || paymentDetails["Total Pay"] === null || paymentDetails["Total Pay"] === "") {
            toast.warn("Please Fill Total Pay", {
                containerId: "P",
            });
            return;
        }
        if (!logoUrl) {
            toast.warn("Please Fill a Log ", {
                containerId: "P",
            });
            return;
        }
        setresumeDetails(`
        <!DOCTYPE html>
        <html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office">
        
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width,initial-scale=1">
          <meta name="x-apple-disable-message-reformatting">
          <title></title>
          <!--[if mso]>
          <noscript>
            <xml>
              <o:OfficeDocumentSettings>
                <o:PixelsPerInch>96</o:PixelsPerInch>
              </o:OfficeDocumentSettings>
            </xml>
          </noscript>
          <![endif]-->
          <style>
            table,
            td,
            div,
            h1,
            p {
              font-family: Arial, sans-serif;
              color: #000;
            }
          </style>
        </head>
        
        <body style="margin:0;padding:0;">
          <table role="presentation" style="width:100%;border-collapse:collapse;border:0;border-spacing:0;background:#ffffff;">
            <tr>
              <td align="center" style="padding:0;">
                <table role="presentation"
                  style="width:600px;border-collapse:collapse;border:1px solid #e7e7e7;border-spacing:0;text-align:center; background-color: #f9f9f9;">
                  <tr>
                    <td style="padding:0px 30px;">
                      <table role="presentation" style="width:100%;border-collapse:collapse;border:0;border-spacing:0;">
                        <tr>
                          <td style="padding:0 0 36px 0;color:#153643;">
        <strong style="font-size:5px;">Offer Letter</strong>
        <p> <img src="${logoUrl}"  width="100"/></p>
          <p><strong>To,</strong></p>
          <p><strong>${editedCandidate.full_name}</strong></p>
           <p> ${editedCandidate.address}</p>
          <p>Dear ${editedCandidate.full_name},</p>
      
          <p>With reference to your application/CV sent to us for employment and subsequent interview, we are pleased to offer you the post of <strong>“${jobRole}”</strong>  with <strong>${officeName}</strong> on, inter alia, the following terms and conditions.</p>
      
          <p>This offer comes into effect from <strong>${formatDate(todaysDate)}</strong> To <strong>${formatDate(expiryDate)}</strong>. Your total pay package will be Rs., ${JSON.stringify(paymentDetails["Total Pay"])}/- per month, and your remuneration will be shown in the attached <strong>Appendix 1</strong>.</p>
      
          <p><strong>Duties:</strong></p>
          <p>You will devote all your time and give your best endeavors to diligently discharge your duties. You shall not, during the period of employment with us, enter into services of, or be employed in any capacity or for any purpose whatsoever by any person, firm, or corporation other than <strong>${officeName}</strong>. Additionally, you will not, during the said period of your employment, be engaged in any business, enterprise, or undertaking other than this employment.</p>
      
          <p><strong>Disclosure of employer’s information:</strong></p>
          <p>You will be responsible for maintaining the secrecy and confidentiality of, and shall not divulge or disclose to anyone, the information or data obtained or acquired by you during your employment with the company.</p>
      
          <p><strong>Probation period:</strong></p>
          <p>You will be on probation for a period of six months from the joining, which may be extended at the sole discretion of the management for a further period, as considered appropriate. You will continue to be on probation until a specific order confirming your service has been issued to you. If an order extending your probation or confirming your service has not been issued, it will be deemed that your services have been terminated on the expiry of the probation period fixed.</p>
          </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</td>
</tr>
</table>
</body>
</html>
      `)
        // pdfConvertFunction(Data)
        setflagReadactor(true)
    }
    const print = () => {
        // window.print();
        const printWindow = window.open('', '_blank');

        if (printWindow) {
            printWindow.document.write(`
                    ${resumeDetails}
              `);
            setTimeout(() => {
                printWindow.document.close();

                printWindow.print();
            }, 1000);

        } else {
            console.error('Failed to open print window');
        }
    };
    const handleSelect = (event) => {
        const value = event.target.value;
        const isChecked = event.target.checked;
     
        if (isChecked) {
          //Add checked item into checkList
          setSelectedAttachement([...SelectedAttachement, value]);
        } else {
          //Remove unchecked item from checkList
          const filteredList = SelectedAttachement.filter((item) => item !== value);
          setSelectedAttachement(filteredList);
        }
      };
      const handleDownload = (data) => {
        window.open(data.value, "blank_");
      }
    return (
        <div className="cardDeatils">
            <ToastContainer
                enableMultiContainer
                containerId={"P"}
                position="bottom-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <div className="sub-head">Office Details</div>
            <div className="cardData">
                <div className="row xilliFirst">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label for="" className="form-label">
                                Candidate Name : <span className="text-danger ml-1">*</span>{" "}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                name="full_name"
                                id="full_name"
                                placeholder="Enter Candidate Name..."
                                value={editedCandidate.full_name}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="form-group">
                            <label for="" className="form-label">
                                Email Id : <span className="text-danger ml-1">*</span>{" "}
                            </label>
                            <input
                                type="text"
                                placeholder="Enter email Id"
                                className="form-control"
                                name="email_id"
                                id="email_id"
                                value={editedCandidate.email_id}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="form-group">
                            <label for="" className="form-label">
                                Job Role : <span className="text-danger ml-1">*</span>{" "}
                            </label>
                            <input
                                type="text"
                                id="JobRole"
                                placeholder="Job Role..."
                                className="form-control"
                                // name="email_id"
                                value={jobRole}
                                onChange={(e) => setJobRole(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label for="" className="form-label">
                                Today's Date: <span className="text-danger ml-1">*</span>{" "}
                            </label>
                            <div className="col-md-5 pr-0 pl-1">
                                <DatePicker
                                    selected={todaysDate}
                                    className="form-control"
                                    dateFormat="dd/MM/yyyy"
                                    // onChange={(date)=>setFrom(date)}
                                    onChange={(date) => handleFromDateChange(date)}
                                    showYearDropdown
                                    showMonthDropdown
                                    placeholderText="Select date "
                                    minDate={new Date()}
                                />
                            </div>

                        </div>
                        <div className="form-group">
                            <label for="" className="form-label">
                                Address: <span className="text-danger ml-1">*</span>{" "}
                            </label>
                            <textarea
                                type="text"
                                className="form-control"
                                placeholder="Enter address..."
                                name="address"
                                value={editedCandidate.address}
                                onChange={handleInputChange}
                            ></textarea>
                        </div>
                        <div className="form-group">
                            <label for="" className="form-label">
                                Expiry Date: <span className="text-danger ml-1">*</span>{" "}
                            </label>
                            <div className="col-md-5 pr-0 pl-1">
                                <DatePicker
                                    selected={expiryDate}
                                    className="form-control"
                                    dateFormat="dd/MM/yyyy"
                                    // onChange={(date)=>setFrom(date)}
                                    onChange={(date) => handleExpiryDateChange(date)}
                                    showYearDropdown
                                    showMonthDropdown
                                    id="ExpiryDate"
                                    placeholderText="Select date "
                                    minDate={todaysDate}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label for="" className="form-label">
                                Company Name: <span className="text-danger ml-1">*</span>{" "}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Office Name..."
                                // name="address"
                                id="companyName"
                                value={officeName}
                                onChange={(e => setOfficeName(e.target.value))}
                            ></input>
                        </div>
                        {Object.keys(paymentDetails).map((fieldName) => (
                            <div key={fieldName} className="form-group">
                                <label htmlFor={fieldName} className="form-label">
                                    {fieldName}: <span className="text-danger ml-1">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="totalPay"
                                    placeholder={`Enter ${fieldName}...`}
                                    name={fieldName}
                                    value={paymentDetails[fieldName]}
                                    onChange={(e) => setpaymentDetails((prevDetails) => ({
                                        ...prevDetails,
                                        [fieldName]: e.target.value
                                    }))}
                                />
                            </div>
                        ))}
                         <div className="form-group">
                            <label for="" className="form-label">
                               Attachment: <span className="text-danger ml-1">*</span>{" "}
                            </label>



                            {SelectedAttachement.map((item, index) => {
            return (
              <div className="chip">
                <p className="chip-label">{item.label}</p>
              </div>
            );
          })}
          {console.log(attachmentDetails,"attachmentDetailsattachmentDetailsattachmentDetails")}
<div className="checkbox_makeoffer">
{attachmentDetails.map((item, index) => {
            return (
               
              <div key={item.id} className="checkbox-container">
                 <FiDownload  onClick={() => handleDownload(item)} className="me-2"/>
                <input
                  type="checkbox"
                  name="languages"
                  value={item.value}
                  onChange={handleSelect}
                />
                <label>{item.label}</label>
              </div>
            
            );
          })}
            </div>
                            {/* <MultiSelect value={SelectedAttachement} onChange={(e) => setSelectedAttachement(e.value)} options={attachmentDetails} optionLabel="label" display="chip"
                            placeholder="Select Attachment" maxSelectedLabels={3} className="w-full md:w-20rem w-100" /> */}
                        </div>
                        {console.log(SelectedAttachement,"ttttttttttttttttttttttttttttttt")}
                       
                    </div>
                    {flagReadactor ?
                        <div className="col-md-6">
                            <div className="resumeWrap" style={{ height: "97%" }}>
                                <div className="col-md-12 p-0 position-relative">
                                    <ReactQuill
                                        theme="snow"
                                        value={resumeDetails}
                                        onChange={(e) => setresumeDetails(e)}
                                        placeholder="Add Email Content"
                                    //   modules={modules}
                                    />
                                </div>
                            </div>
                        </div> : ""}
                    <div className="col-md-12">
                        <div className="childIssueses">
                            <a className="btn-btn btn btn-btn2" onClick={(e) => generateEmail()}>Generate</a>

                            {flagReadactor && (
                                <>
                                    <a className="btn-btn btn btn-btn2 bg-success" onClick={(e) =>(setSendEmailPopupShow(true))}>Send Mail</a>
                                    <a className="btn-btn btn btn-btn2 bg-primary" onClick={(e) => print()}>Print</a>
                                    <a className="btn-btn btn btn-btn2 bg-secondary" onClick={(e) => {
                                        setEditedCandidate({ ...candidate });
                                        setflagReadactor(false);
                                    }}>Reset</a>
                                </>
                            )}
                        </div>
                    </div>

                </div>
                {sendEmailPopupShow ?
                    <div className="col-md-12">
                        <SendEmailComponent closePopup={closePopup} candidateDetails={editedCandidate} resumeDetails={resumeDetails} SelectedAttachement={SelectedAttachement}> </SendEmailComponent>
                        {/* <ReactQuill
                            value={editableValuesAI}
                            onChange={handleQuillChangeAI}
                        />
                        <div className="childIssueses"  >
                            <a className="btn btn-save" onClick={(e) => sendMail()}>Send Mail</a>
                        </div> */}
                    </div>
                    : ""}
            </div>
        </div>
    );
}
export default OfficeDetails;
